<template>
  <div class="position-relative">
    <div :id="mapContainerId" class="w-100 map-container">
      <div
        :class="
          viewMode == 'detail' || viewMode == 'accept'
            ? 'd-none'
            : 'marker-custom'
        "
      ></div>
    </div>
  </div>
</template>
<style scoped>
.map-container {
  position: relative;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 300px;
}
.marker-custom {
  top: 31%;
  left: 45%;
  position: absolute;
  background-image: url("../../public/img/marker.png");
  background-size: cover;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

::v-deep .mapboxgl-marker {
  background-image: url("../../public/img/marker.png");
  background-size: 35px 35px;
  background-position: center;
  width: 27px;
  height: 35px;
  cursor: pointer;
  z-index: 1;
}

::v-deep .mapboxgl-marker svg {
  display: none;
}
</style>
<script>
import mapboxgl from "mapbox-gl";
import MapApi from "../moduleApi/MapApi";
import MethodService from "../service/MethodService";

export default {
  // Inject elForm to prevent "Cannot read properties of undefined (reading 'trigger')" error
  // This is a known issue with Element UI and Vue 2.7
  inject: {
    elForm: {
      default: null,
    },
    elFormItem: {
      default: null,
    },
  },
  props: {
    value: Object,
    cordinatesValue: Array,
    id: String,
    viewMode: String,
  },
  data() {
    return {
      mapContainerId: null,
      mData: {
        dataDefault: {
          token:
            "pk.eyJ1Ijoic2l0ZW5zYyIsImEiOiJjbDV2dHlja3MwZDdiM2lwOWtqaGJ4dTNnIn0.baIM03zTvYrPzEJZOlDtYw",
          style: "mapbox://styles/mapbox/streets-v11",
          mapDataObject: {
            value: [],
            geoJsonData: {
              type: "",
              geometry: {},
            },
          },
          cordinatesValueProps: [],
        },
      },
    };
  },

  methods: {
    async fn_initMap(map) {
      let _this = this;
      mapboxgl.accessToken = this.mData.dataDefault.token;
      if (MethodService.isUndefined(map)) {
        map = new mapboxgl.Map({
          container: _this.mapContainerId, // container id
          style: _this.mData.dataDefault.style, // stylesheet location
          center: MethodService.isUndefined(_this.cordinatesValue)
            ? [105.75, 21]
            : _this.cordinatesValue, // starting position [lng, lat]
          zoom: 15, // starting zoom
        });
        if (this.viewMode == "detail" || this.viewMode == "accept") {
          new mapboxgl.Marker()
            .setLngLat(
              MethodService.isUndefined(_this.cordinatesValue)
                ? [105.75, 21]
                : _this.cordinatesValue
            )
            .addTo(map);
        }
      }
      // eslint-disable-next-line no-undef
      let geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        marker: null,
        mapboxgl: mapboxgl,
      });
      map.addControl(geocoder);

      map.addControl(new mapboxgl.NavigationControl());
      _this.mData.dataDefault.mapDataObject = await _this.fn_getGeoJsonData(
        map
      );
      _this.$emit("update", _this.mData.dataDefault.mapDataObject);
      map.on("mouseup", async function () {
        _this.mData.dataDefault.mapDataObject = await _this.fn_getGeoJsonData(
          map
        );
        _this.$emit("update", _this.mData.dataDefault.mapDataObject);
      });
      map.on("wheel", async function () {
        _this.mData.dataDefault.mapDataObject = await _this.fn_getGeoJsonData(
          map
        );
        _this.$emit("update", _this.mData.dataDefault.mapDataObject);
      });
      map.on("load", function () {
        // Listen for the `result` event from the Geocoder
        // `result` event is triggered when a user makes a selection
        //  Add a marker at the result's coordinates
        geocoder.on("result", async function (e) {
          let res = await MapApi.searchByLngLat(
            {
              long: e.result.center[0],
              lat: e.result.center[1],
            },
            mapboxgl.accessToken
          );
          let featureLast = res.features.pop();
          let result = {
            value: [e.result.center[0], e.result.center[1]],
            geoJson: {
              type: featureLast.geometry.type,
              coordinates: res.query,
            },
          };
          _this.mData.dataDefault.mapDataObject = result;
          _this.$emit("update", _this.mData.dataDefault.mapDataObject);
        });
      });
      _this.mData.mapBox = map;
    },
    fn_isNull(value) {
      return MethodService.isNull(value);
    },

    async fn_getGeoJsonData(map) {
      let result = await MapApi.searchByLngLat(
        {
          long: map.getCenter().lng,
          lat: map.getCenter().lat,
        },
        mapboxgl.accessToken
      );
      let featureLast = result.features.pop();
      return {
        value: [map.getCenter().lng, map.getCenter().lat],
        geoJson: {
          type: featureLast.geometry.type,
          coordinates: result.query,
        },
      };
    },
  },
  created() {
    // Generate unique ID for map container to avoid conflicts with multiple instances
    this.mapContainerId =
      this.id || "map-" + Math.random().toString(36).substring(2, 11);
  },
  mounted: async function () {
    await this.fn_initMap();
  },
};
</script>
